import React from 'react';
import {Link} from "@nextui-org/link";
import {Mail} from 'lucide-react';
import {Instagram} from 'lucide-react';
import {Button} from '@nextui-org/react';



const Footer = () => {
    const handleClickUrl = (url) => {
        window.open(url, '_blank',);
    };
    
    return (
        <div>
            <footer className="bg-primary text-white mt-12 py-12">
                <div className="container mx-auto px-4 text-center">
                    <div className="flex flex-col justify-center items-center gap-3 mb-4 ">
                        <div className='flex gap-2 items-center'>
                            <Mail size={24} color="#ffffff" />
                            <p className="text-lg">vortexiai.business@gmail.com</p>
                        </div>
                        <Button
                            onClick={() =>
                                handleClickUrl(
                                    'https://www.instagram.com/vortexi.io/'
                                )
                            }
                            variant="underlined"
                            className="rounded-full px-3 py-0"
                        >
                            <Instagram
                                color="#fff"
                                size={18}
                                strokeWidth={2}
                            />
                        </Button>
                    </div>
                    <div className="flex gap-3 w-full justify-center py-2">
                        <Link href="terms-of-services" aria-current="page" className=" text-sm text-[#fff]">
                            Terms of Services
                        </Link>
                        <Link href="privacy-policy" className="text-sm text-[#fff]" aria-current="page">
                            Privacy Policy
                        </Link>
                    </div>
                    <p className="text-sm">
                        © Made by a Student Vortexi All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
